import React, { useState } from "react";
import { Box, Button, Card, Chip, CircularProgress, IconButton, Stack, Typography, Dialog, DialogTitle, DialogContent, DialogActions, List, ListItem, ListItemText, ListItemAvatar, Avatar, Tooltip } from "@mui/material";
import { BIBlue } from "../../assets/helpers";
import BusinessIcon from "@mui/icons-material/Business";
import AddIcon from "@mui/icons-material/Add";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import VerifiedIcon from "@mui/icons-material/Verified";
import PublicIcon from "@mui/icons-material/Public";
import { useSelector } from "react-redux";
import PhoneIcon from "@mui/icons-material/Phone";
import MapPinIcon from "@mui/icons-material/Place";
import PersonIcon from "@mui/icons-material/Person";
import MailIcon from "@mui/icons-material/Mail";
import AddTradeModal from "../common/AddTradeModal";
import AddWebsiteModal from "../common/AddWebsiteModal";
import AddPhoneNumberModal from "../common/AddPhoneNumberModal";
import DeleteConfirmation from "../common/DeleteConfirmation";
import { CHECK_IF_COMPANY_HAS_CLIENT, DELETE_COMPANY_TRADE, FETCH_CURRENT_COMPANY_MERGE_MAPPING } from "../../constant/Apipath";
import { Postrequestcall } from "../../request/Postrequest";
import { useEffect } from "react";
import AddContactInfo from "../common/AddContactInfo";
import Loader from "../../common/Loader";
import { useLocation, useNavigate } from "react-router-dom";
import { English } from "../../constant/EnglishFallback";
import ClaimCompanyClientModal from "./ClaimCompanyClientModal";
import { showErrorToast } from "../../toast/toast";

const CompanyAboutSection = ({
  companyDetails,
  tradeList,
  companyAddress,
  onTradesSaveSuccessfully,
  onCompanyDetailsSaveSuccessfully,
  onCompanyAddressSaveSuccessfully
}) => {
  const { loginData, multiLanguageData } = useSelector((state) => state?.main);
  const currentUserId = loginData?.userInformation?.UserId ?? 0;
  const LanguageData = multiLanguageData?.Companies || {};
  const {
    TEXT_ABOUT_INFO = English.Companies.TEXT_ABOUT_INFO,
    NO_INFORMATION_ABOUT = English.Companies.NO_INFORMATION_ABOUT,
    TEXT_NO_DATA_INFO_SUBTEXT = English.Companies.TEXT_NO_DATA_INFO_SUBTEXT,
    TEXT_TRADE_COMPONY = English.Companies.TEXT_TRADE_COMPONY,
    TEXT_ADD_WEBSITE = English.Companies.TEXT_ADD_WEBSITE,
    TEXT_ADD_PHONE_NUMBER = English.Companies.TEXT_ADD_PHONE_NUMBER,
    BUTTON_ADD_ADDRESS_AND_CONTACT = English.Companies.BUTTON_ADD_ADDRESS_AND_CONTACT,
    BUTTON_ADD_ANOTHER_ADDRESS_AND_CONTACT = English.Companies.BUTTON_ADD_ANOTHER_ADDRESS_AND_CONTACT,
    TEXT_ADD_CONTACT_INFO = English.Companies.TEXT_ADD_CONTACT_INFO,
    TEXT_ADD_ADDRESS_TITLE = English.Companies.TEXT_ADD_ADDRESS_TITLE,
    TEXT_DELETE_COMPANY_TARDES = English.Companies.TEXT_DELETE_COMPANY_TARDES,
    TEXT_DELETE_COMPANY_TARDES_DEC = English.Companies.TEXT_DELETE_COMPANY_TARDES_DEC
  } = LanguageData || {};
  const [showAddTradesModal, setShowAddTradeOpenModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedTradeId, setSelectedTradeId] = useState(0);
  const [confirmDeleteModalOpen, setConfirmDeleteModalOpen] = useState(false);
  const [basicDetailsModalType, setBasicDetailsModalType] = useState(null);
  const [showClaimClientModal, setShowClaimClientModal] = useState(false);
  const [claimLoading, setClaimLoading] = useState(false);
  const [mergeMapping, setMergeMapping] = useState(null);
  const [showAllChildCompaniesModal, setShowAllChildCompaniesModal] = useState(false);
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const handleMergeMappingNavigate = (mapping) => {
    // if (!mapping?.id) return;
    // if (mapping.manufacturer) {
    //   navigate(`/manufacture/${mapping.id}`);
    // } else {
    //   navigate(`/company/${mapping.id}`);
    // }
  };

  useEffect(() => {
    if (companyDetails?.id) {
      fetchMergeMapping();
    }
  }, [companyDetails?.id]);

  const fetchMergeMapping = async () => {
    try {
      const payload = {
        CompanyId: Number(companyDetails.id),
        UserId: currentUserId
      };
      const res = await Postrequestcall(FETCH_CURRENT_COMPANY_MERGE_MAPPING, payload, loginData?.accessToken);
      if (res?.data?.data && res?.data?.data?.mergeList?.length > 0) {
        setMergeMapping(res.data.data);
      } else {
        setMergeMapping(null);
      }
    } catch (error) {
      console.error("fetchMergeMapping-> Error:", error);
    }
  };

  const onTradeItemClick = (id) => {
    if (!id) return;
    setSelectedTradeId(id);
    setConfirmDeleteModalOpen(true);
  };

  const handleWebRedirect = (inputUrl) => {
    try {
      let fullUrl = new URL(inputUrl);
      let baseUrl = `${fullUrl.hostname}`;
      window.open(`http://${baseUrl}`, "_blank");
    } catch (error) {
      window.open(`http://${inputUrl}`, "_blank");
    }
  };

  const extractBaseURL = (inputUrl) => {
    try {
      let fullUrl = new URL(inputUrl);
      let baseUrl = `${fullUrl?.hostname}`;
      return baseUrl;
    } catch (error) {
      console.log("extractBaseURL-> Error When Extracting base URL: ", error);
      return inputUrl;
    }
  };

  const handleClaimCompany = async () => {
    if (!companyDetails?.id || companyDetails?.verified === true) return;
    try {
      setClaimLoading(true);
      const payload = {
        UserEmail: loginData?.userInformation?.Email,
        CompanyId: Number(companyDetails?.id) || 0
      };
      const response = await Postrequestcall(
        CHECK_IF_COMPANY_HAS_CLIENT,
        payload,
        loginData?.accessToken
      );

      const { status, message, errorMessage, data, nrOfRecords } = response.data;

      if (status === false) {
        showErrorToast(errorMessage || message || "Something went wrong.");
        return;
      }
      if(message.toLowerCase().includes("claimed by someone")){
        showErrorToast(message || "Something went wrong while checking the claim status.");
        return;
      }

      if (nrOfRecords === 0 && !message.toLowerCase().includes("informed") && !message.toLowerCase().includes("already claimed")) {
        setShowClaimClientModal(true);
        return;
      }


      showErrorToast(message || "Something went wrong while checking the claim status.");
    } catch (error) {
      console.error("handleClaimCompany-> Error While Checking Claim Status:", error);
      showErrorToast("Something went wrong while checking the claim status.");
    } finally {
      setClaimLoading(false);
    }
  };

  const handleDeleteTrade = async () => {
    try {
      setLoading(true);
      const obj = {
        UserId: currentUserId,
        ReturnRecordError: true,
        SoftDelete: true,
        DeleteList: [
          {
            TradeId: selectedTradeId,
            CompanyId: companyDetails.id
          }
        ]
      };
      const res = await Postrequestcall(DELETE_COMPANY_TRADE, obj, loginData?.accessToken);
      if (res.status === 201) {
        onTradesSaveSuccessfully();
      }
      // Always close the confirmation modal after the action (success or failure)
      setConfirmDeleteModalOpen(false);
      setSelectedTradeId(0);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setConfirmDeleteModalOpen(false);
      setSelectedTradeId(0);
      console.error("handleDeleteTrade-> Error When Deleting Companies Trade: ", error);
    }
  };

  if (loading) {
    return <Loader />;
  }

  const normalizeAddressRecord = (rec) => ({
    address: rec?.address || rec?.Address || "",
    city: rec?.city || rec?.City || "",
    province: rec?.province || rec?.Province || "",
    postalCode: rec?.postalCode || rec?.PostalCode || "",
    country: rec?.country || rec?.Country || "",
    contactPerson: rec?.contactPerson || rec?.ContactPerson || "",
    phone: rec?.phone || rec?.Phone || "",
    email: rec?.email || rec?.Email || ""
  });

  const formatAddressString = (rec) =>
    [rec?.address, rec?.city, rec?.province, rec?.postalCode, rec?.country]
      .filter((part) => part && String(part).trim() !== "")
      .join(", ");

  const renderContactInfo = () => {
    const website = companyDetails?.webSite;
    const phone = companyDetails?.phone;
    const addressRecords = (companyAddress || []).map(normalizeAddressRecord);
    const addressStrings = addressRecords.filter(
      (rec) => !rec.contactPerson && !rec.phone && !rec.email && formatAddressString(rec)
    );

    const hasContactInfo =
      website || phone || addressRecords.length > 0 || !pathname?.includes("proxySite");

    if (!hasContactInfo) {
      return null;
    }

    const showAddButton = !pathname?.includes("proxySite");

    const renderRecordCard = (rec, i) => (
      <Stack
        key={i}
        direction="column"
        spacing={0.75}
        sx={{
          mt: 1,
          p: 1.5,
          borderRadius: 2,
          border: "1px solid",
          borderColor: "grey.200"
        }}>
        {formatAddressString(rec) && (
          <Stack direction="row" spacing={2} sx={{ alignItems: "flex-start" }}>
            <MapPinIcon color="primary" sx={{ mt: 0.25 }} fontSize="small" />
            <Typography variant="body2">{formatAddressString(rec)}</Typography>
          </Stack>
        )}
        {rec.contactPerson && (
          <Stack direction="row" spacing={2} sx={{ alignItems: "center" }}>
            <PersonIcon color="primary" fontSize="small" />
            <Typography variant="body2">{rec.contactPerson}</Typography>
          </Stack>
        )}
        {rec.phone && (
          <Stack direction="row" spacing={2} sx={{ alignItems: "center" }}>
            <PhoneIcon color="primary" fontSize="small" />
            <a href={`tel:${rec.phone}`} style={{ color: "inherit", textDecoration: "none" }}>
              <Typography variant="body2">{rec.phone}</Typography>
            </a>
          </Stack>
        )}
        {rec.email && (
          <Stack direction="row" spacing={2} sx={{ alignItems: "center" }}>
            <MailIcon color="primary" fontSize="small" />
            <a href={`mailto:${rec.email}`} style={{ color: "inherit", textDecoration: "none" }}>
              <Typography variant="body2">{rec.email}</Typography>
            </a>
          </Stack>
        )}
      </Stack>
    );

    return (
      <Stack spacing={1.5}>
        {phone && !addressRecords.length && (
          <Stack direction="row" spacing={2} sx={{ alignItems: "center" }}>
            <PhoneIcon color="primary" fontSize="small" />
            <a href={`tel:${phone}`} style={{ color: "inherit", textDecoration: "none" }}>
              <Typography variant="body2">{phone}</Typography>
            </a>
          </Stack>
        )}

        {addressRecords.length > 0 ? (
          <>
            {addressRecords.map((rec, i) => renderRecordCard(rec, i))}
            {showAddButton && (
              <Box sx={{ textAlign: "end" }}>
                <Button
                  color="primary"
                  onClick={() => {
                    setBasicDetailsModalType("address");
                  }}>
                  {BUTTON_ADD_ANOTHER_ADDRESS_AND_CONTACT}
                </Button>
              </Box>
            )}
          </>
        ) : addressStrings.length > 0 ? (
          <>
            {addressStrings.map((rec, i) => (
              <Stack key={i} direction="row" spacing={2} sx={{ alignItems: "flex-start" }}>
                <MapPinIcon color="primary" sx={{ mt: 0.25 }} fontSize="small" />
                <Typography variant="body2">{formatAddressString(rec)}</Typography>
              </Stack>
            ))}
            {showAddButton && (
              <Box sx={{ textAlign: "end" }}>
                <Button
                  color="primary"
                  onClick={() => {
                    setBasicDetailsModalType("address");
                  }}>
                  {BUTTON_ADD_ADDRESS_AND_CONTACT}
                </Button>
              </Box>
            )}
          </>
        ) : (
          showAddButton && (
            <Stack direction="row" sx={{ alignItems: "center" }} spacing={2}>
              <MapPinIcon color="primary" fontSize="small" />
              <Button
                variant="outlined"
                color="primary"
                onClick={() => {
                  setBasicDetailsModalType("address");
                }}
                style={{ width: "100%" }}>
                {TEXT_ADD_CONTACT_INFO}
              </Button>
            </Stack>
          )
        )}
      </Stack>
    );
  };

  return (
    <>
      <Card className="pagelist-content" sx={{ p: 2 }}>
        <Stack sx={{ justifyContent: "space-between", alignItems: { xs: "flex-start", sm: "center" }, mb: 1 }} direction={{ xs: "column", sm: "row" }} spacing={1}>
          <Typography variant="h6">{TEXT_ABOUT_INFO}</Typography>
          {companyDetails?.verified === true ? (
            <VerifiedIcon sx={{ color: BIBlue, fontSize: "1.4rem" }} />
          ) : companyDetails?.id ? (
            <Button
              variant="outlined"
              color="primary"
              startIcon={claimLoading ? <CircularProgress size={16} color="inherit" /> : <HowToRegIcon />}
              onClick={handleClaimCompany}
              disabled={claimLoading}
              sx={{
                textTransform: "none",
                borderRadius: "30px",
                whiteSpace: "nowrap"
              }}>
              {claimLoading ? "Checking..." : "Claim This Company"}
            </Button>
          ) : null}
        </Stack>
        {(() => {
          const allMappingItems = mergeMapping ? [mergeMapping, ...(mergeMapping.mergeList || [])] : [];
          const childMappingObjs = allMappingItems.filter(item => item.status === "Child");
          const isMappingEmpty = !mergeMapping || (mergeMapping.status === "Parent" && childMappingObjs.length === 0);

          return tradeList?.length === 0 && !companyDetails?.about && isMappingEmpty && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: 250,
              flexDirection: "column",
              gap: 1
            }}>
            <Typography variant="body1">{NO_INFORMATION_ABOUT}</Typography>
            <Typography variant="body2"  sx={{color: "text.secondary",  mb: 2 }}>
              {TEXT_NO_DATA_INFO_SUBTEXT}
            </Typography>
          </Box>
          );
        })()}

        {(() => {
          const allMappingItems = mergeMapping ? [mergeMapping, ...(mergeMapping.mergeList || [])] : [];
          const parentMappingObj = allMappingItems.find(item => item.status === "Parent") || mergeMapping;
          const childMappingObjs = allMappingItems.filter(item => item.status === "Child");
          const isCurrentChild = mergeMapping?.status === "Child";
          const isCurrentParent = mergeMapping?.status === "Parent";

          if (!mergeMapping) return null;
          if (isCurrentParent && childMappingObjs?.length === 0) return null;
          if (isCurrentChild && !parentMappingObj) return null;

          return (
          <Box sx={{ 
            mt: 3, 
            mb: 2, 
            p: 2.5, 
            borderRadius: 3, 
            bgcolor: "rgba(25, 118, 210, 0.04)", 
            border: "1px solid rgba(25, 118, 210, 0.12)",
            display: "flex",
            flexDirection: "column",
            gap: 1.5,
            transition: "all 0.3s ease",
            '&:hover': { boxShadow: "0 4px 12px rgba(0,0,0,0.05)" }
          }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
              <BusinessIcon sx={{ color: BIBlue, fontSize: 20 }} />
              <Typography variant="subtitle2" sx={{ color: BIBlue, fontWeight: 700, textTransform: "uppercase", letterSpacing: 0.5 }}>
                {isCurrentChild ? "Parent Company" : `Child Companies (${childMappingObjs.length})`}
              </Typography>
            </Box>
            
            {isCurrentChild && (
              <Box>
                <Chip 
                  label={
                    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                      {parentMappingObj?.name}
                      {parentMappingObj?.verified && (
                        <Tooltip title="This company has been verified" arrow>
                          <VerifiedIcon sx={{ color: BIBlue, fontSize: "1.1rem", flexShrink: 0 }} />
                        </Tooltip>
                      )}
                    </Box>
                  } 
                  onClick={() => handleMergeMappingNavigate(parentMappingObj)}
                  sx={{ 
                    fontWeight: 600, 
                    bgcolor: "white",
                    border: `1px solid ${BIBlue}`,
                    color: BIBlue,
                    py: 0.5,
                    height: 'auto',
                    '& .MuiChip-label': { display: 'block', whiteSpace: 'normal', padding: '6px 12px' },
                    boxShadow: "0px 2px 4px rgba(0,0,0,0.05)",
                    // cursor: "pointer",
                    transition: "all 0.2s",
                    '&:hover': { bgcolor: BIBlue, color: "white" }
                  }}
                />
              </Box>
            )}
            
            {isCurrentParent && (
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.5 }}>
                {childMappingObjs.slice(0, 3).map((mapping) => (
                  <Chip 
                    key={mapping.id} 
                    label={
                      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                        {mapping.name}
                        {mapping?.verified && (
                          <Tooltip title="This company has been verified" arrow>
                            <VerifiedIcon sx={{ color: BIBlue, fontSize: "1.1rem", flexShrink: 0 }} />
                          </Tooltip>
                        )}
                      </Box>
                    } 
                    onClick={() => handleMergeMappingNavigate(mapping)}
                    sx={{ 
                      bgcolor: "white", 
                      border: "1px solid #e0e0e0", 
                      fontWeight: 500,
                      py: 0.5,
                      height: 'auto',
                      '& .MuiChip-label': { display: 'block', whiteSpace: 'normal', padding: '6px 12px' },
                      boxShadow: "0px 1px 3px rgba(0,0,0,0.04)",
                      // cursor: "pointer",
                      transition: "all 0.2s",
                      '&:hover': { borderColor: BIBlue, color: BIBlue, bgcolor: "rgba(25, 118, 210, 0.04)" }
                    }} 
                  />
                ))}
                {childMappingObjs.length > 3 && (
                  <Chip 
                    label={`+${childMappingObjs.length - 3} more`} 
                    onClick={() => setShowAllChildCompaniesModal(true)}
                    sx={{ 
                      cursor: "pointer", 
                      bgcolor: BIBlue, 
                      color: "white", 
                      fontWeight: 600,
                      py: 0.5,
                      height: 'auto',
                      transition: "all 0.2s",
                      boxShadow: "0px 2px 4px rgba(25, 118, 210, 0.25)",
                      '&:hover': { bgcolor: "#1565c0" }
                    }}
                  />
                )}
              </Box>
            )}
          </Box>
          );
        })()}

        {companyDetails?.about && (tradeList?.length !== 0 || !pathname.includes("proxySite")) && (
          <Stack>
            {tradeList?.length !== 0 ? (
              <>
                <div style={{ paddingBottom: "15px" }}>
                  <Stack
                    style={{
                      marginTop: "2%",
                      display: "flex",
                      alignItems: "center",
                      flexWrap: "wrap",
                      gap: "10px 10px"
                    }}
                    direction="row"
                    spacing={0}>
                    {tradeList
                      ?.sort(
                        (a, b) =>
                          a.tradeType?.toLowerCase().localeCompare(b.tradeType?.toLowerCase()) ||
                          a.tradeName
                            ?.trim()
                            .toLowerCase()
                            .localeCompare(b.tradeName?.trim().toLowerCase())
                      )
                      .map((item, index) => {
                        return (
                          <Chip
                            key={index.toString()}
                            label={item.tradeName?.trim()}
                            style={{
                              cursor: !pathname.includes("proxySite") ? "pointer" : "default",
                              backgroundColor:
                                item?.tradeType?.toLowerCase() == "main" ? BIBlue : "null",
                              color: item?.tradeType?.toLowerCase() == "main" ? "white" : "null"
                            }}
                            onClick={() => {
                              if (!pathname.includes("proxySite")) {
                                onTradeItemClick(item?.tradeId ?? 0);
                              } else {
                                return;
                              }
                            }}></Chip>
                        );
                      })}
                    {!pathname.includes("proxySite") && (
                      <IconButton
                        color="primary"
                        size="small"
                        onClick={() => {
                          setShowAddTradeOpenModal(true);
                        }}
                        style={{ backgroundColor: BIBlue, color: "white" }}>
                        <AddIcon style={{ fontSize: "16px" }} />
                      </IconButton>
                    )}
                  </Stack>
                </div>
              </>
            ) : (
              !pathname.includes("proxySite") && (
                <Stack direction="row" sx={{ paddingBottom: 2 }} style={{ marginTop: "10px" }}>
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => {
                      setShowAddTradeOpenModal(true);
                    }}
                    style={{ borderRadius: "30px" }}>
                    {TEXT_TRADE_COMPONY}
                  </Button>
                </Stack>
              )
            )}
          </Stack>
        )}

        <Stack sx={{ gap: 2 }} >
          {(!pathname.includes("proxySite") || companyDetails?.webSite) && (
            <Stack>
              {companyDetails?.webSite ? (
                <Stack direction="row" spacing={2}>
                  <PublicIcon color="primary" />
                  <span
                    style={{
                      color: BIBlue,
                      cursor: "pointer",
                      textDecoration: "underline"
                    }}
                    onClick={() => handleWebRedirect(companyDetails?.webSite)}>
                    {extractBaseURL(companyDetails?.webSite)}
                  </span>
                </Stack>
              ) : (
                <Stack direction="row" sx={{ alignItems: "center" }} spacing={2}>
                  <PublicIcon color="primary" />
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => {
                      setBasicDetailsModalType("website");
                    }}
                    style={{ width: "100%" }}>
                    {TEXT_ADD_WEBSITE}
                  </Button>
                </Stack>
              )}
            </Stack>
          )}

          <Box sx={{ mt: 2, pt: 2, borderTop: "1px solid", borderColor: "divider" }}>
            {renderContactInfo()}
          </Box>
        </Stack>
      </Card>

      <ClaimCompanyClientModal
        open={showClaimClientModal}
        onClose={() => setShowClaimClientModal(false)}
        companyDetails={companyDetails}
        onSelectClient={() => setShowClaimClientModal(false)}
      />

      {showAddTradesModal && (
        <AddTradeModal
          open={showAddTradesModal}
          onClose={() => {
            setShowAddTradeOpenModal(false);
          }}
          alreadyTradesSelected={tradeList}
          mainId={companyDetails?.id}
          onTradesSaveSuccessfully={onTradesSaveSuccessfully}
        />
      )}

      {basicDetailsModalType === "website" && (
        <AddWebsiteModal
          open={true}
          onClose={() => {
            setBasicDetailsModalType(null);
          }}
          from="company"
          data={companyDetails}
          onDataSave={onCompanyDetailsSaveSuccessfully}
          onSaveClick={() => {}}
        />
      )}

      {basicDetailsModalType === "phone" && (
        <AddPhoneNumberModal
          open={true}
          onClose={() => {
            setBasicDetailsModalType(null);
          }}
          from="company"
          data={companyDetails}
          onDataSave={onCompanyDetailsSaveSuccessfully}
        />
      )}

      {confirmDeleteModalOpen && (
        <DeleteConfirmation
          open={confirmDeleteModalOpen}
          onClose={() => setConfirmDeleteModalOpen(false)}
          headerText={TEXT_DELETE_COMPANY_TARDES}
          secondaryText={TEXT_DELETE_COMPANY_TARDES_DEC}
          onBadgeClick={handleDeleteTrade}
        />
      )}

      {basicDetailsModalType === "address" && (
        <AddContactInfo
          open={true}
          onClose={() => {
            setBasicDetailsModalType(null);
          }}
          from="company"
          data={companyDetails}
          onDataSave={onCompanyAddressSaveSuccessfully}
        />
      )}

      <Dialog 
        open={showAllChildCompaniesModal} 
        onClose={() => setShowAllChildCompaniesModal(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: { borderRadius: 3 }
        }}
      >
        {(() => {
          const allMappingItems = mergeMapping ? [mergeMapping, ...(mergeMapping.mergeList || [])] : [];
          const childMappingObjs = allMappingItems.filter(item => item.status === "Child");
          return (
            <>
              <DialogTitle sx={{ pb: 1 }}>
                <Typography variant="h6" sx={{ fontWeight: "bold" }}>Child Companies ({childMappingObjs?.length})</Typography>
              </DialogTitle>
              <DialogContent dividers sx={{ p: 0 }}>
                <List sx={{ pt: 0, pb: 0 }}>
                  {childMappingObjs?.map((mapping, index) => (
                    <ListItem 
                      key={mapping.id} 
                      onClick={() => handleMergeMappingNavigate(mapping)}
                      sx={{ 
                        borderBottom: index !== childMappingObjs.length - 1 ? "1px solid #f0f0f0" : "none",
                  px: 3,
                  py: 1.5,
                  // cursor: "pointer",
                  '&:hover': { backgroundColor: "#f9f9f9" }
                }}
              >
                <ListItemAvatar>
                  <Avatar sx={{ bgcolor: "#e3f2fd", color: BIBlue }}>
                    <BusinessIcon />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText 
                  primary={
                    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                      {mapping.name}
                      {mapping?.verified && (
                        <Tooltip title="This company has been verified" arrow>
                          <VerifiedIcon sx={{ color: BIBlue, fontSize: "1.1rem", flexShrink: 0 }} />
                        </Tooltip>
                      )}
                    </Box>
                  } 
                  primaryTypographyProps={{ fontWeight: 500 }}
                />
              </ListItem>
            ))}
          </List>
        </DialogContent>
        <DialogActions sx={{ px: 3, py: 2 }}>
          <Button onClick={() => setShowAllChildCompaniesModal(false)} variant="contained" color="primary" disableElevation sx={{ borderRadius: 2 }}>
            Close
          </Button>
        </DialogActions>
            </>
          );
        })()}
      </Dialog>
    </>
  );
};

export default CompanyAboutSection;

